import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import Snackbar from 'components/Snackbar'

import classes from './Snackbar.scss'

class SnackbarContainer extends React.Component {
  static propTypes = {
    notifications: PropTypes.array.isRequired,

    dispatch: PropTypes.func.isRequired
  }

  static defaultProps = {
    notifications: []
  }

  render () {
    if (!this.props.notifications.length) return null

    return <div className={classes.container}>
      {this.props.notifications
        .map(action => <Snackbar {...action} dispatch={this.props.dispatch} key={`snackbar-${action.id}`} />)
      }
    </div>
  }
}

const mapStateToProps = (state, ownProps) => ({
  notifications: state.notifications
})
const mapDispatchToProps = (dispatch) => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(SnackbarContainer)



// WEBPACK FOOTER //
// ./src/containers/Snackbar/SnackbarContainer.js